exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".th-bold th {\n  font-size: 1rem;\n  letter-spacing: .15px;\n  font-weight: 400;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  height: 74px;\n  width: 40%; }\n\ntable td input {\n  color: #777777 !important;\n  font-size: 0.875rem !important;\n  letter-spacing: .25px; }\n\n.input-base {\n  width: 100%; }\n\n.switchBase {\n  color: #ee5c4e !important; }\n  .switchBase.checked {\n    color: #79C552 !important; }\n\n.switch-bar {\n  background-color: #777777 !important; }\n\n.root-rabat-level::after {\n  border-bottom: 2px solid red; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/complex/customTableSimple/index.scss
// module id = 1180
// module chunks = 0